var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center",class:_vm.isMobile ? 'mb-2' : ''},[_c('a',{attrs:{"href":"https://form.yomi.digital/","target":"_blank"}},[_c('p',{staticClass:"buble-text",class:{ 'mb-0': _vm.isMobile }},[_vm._v(" "+_vm._s(_vm.$t("menu.talk"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }